import lazyLoading from '../../lazyLoading'

import childrenOne  from './children-one';
import exception  from './exception';


export default [
  {
    path: 'first',
    meta: {
      title: '一级页面',
      icon: 'history',
      activeIcon: 'history'
    },
    component: lazyLoading('views/pages/secondRouterView'),
    children: childrenOne
  },
  {
    path: 'result',
    meta: {
      title: '错误页',
      icon: 'close-circle',
      activeIcon: 'close-circle'
    },
    component: lazyLoading('views/pages/secondRouterView'),
    children: exception
  },
  {
    path: 'person',
    meta: {
      title: '个人页',
      icon: 'user',
      activeIcon: 'user'
    },
    component: lazyLoading('views/pages/first'),
    children: []
  }
]